export class SubjectProficiency {
  idPrueba: number;
  nombrePrueba: String;
  fecha: Date;
  fechaPrueba: String;
  entidad: String;
  puntaje: String;
  minRango: number;
  archivoAdjunto: String;
  pathArchivo: String;
  tipoPuntaje: String;
  isDecimal: boolean;
  maxRango: number;
  vigencia: number;
  puntajePattern: String;
}
